import { FunctionComponent } from 'react'
import Modal from '@/components/Modal'
import { Button } from '@conexasaude/hero'
import { useModalContext } from '@/components/Modal/contexts/ModalContext'
import { useRealtimeAttendanceContext } from '@/modules/RealtimeAttendance/contexts/RealtimeAttendanceContext'
import { useHistory } from 'react-router'

const AttendanceStartedModal: FunctionComponent = () => {
  const { closeModal } = useModalContext()
  const { push } = useHistory()
  const {
    realtimeAttendance: { nextScheduled },
  } = useRealtimeAttendanceContext()

  return (
    <Modal id="ATTENDANCE_STARTED">
      <div>
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <p className="w-100 mb-5">
            Sua consulta começará em alguns minutos. Veja nossas dicas para ter
            uma boa consulta.
          </p>
          <div className="d-flex justify-content-end flex-lg-row flex-column-reverse w-100 footer-modal-buttons">
            <Button
              onClick={() => {
                closeModal()
                push('/atendimento-agendado/' + nextScheduled?.id)
              }}
            >
              Ver as dicas
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  )
}

export default AttendanceStartedModal
